import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/fb/github/brigand/pattahn/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pattahn"
    }}>{`pattahn`}</h1>
    <p><a parentName="p" {...{
        "href": "https://brigand.github.io/pattahn/"
      }}>{`API Documentation`}</a></p>
    <h2 {...{
      "id": "intro"
    }}>{`Intro`}</h2>
    <p>{`This library allows dynamic pattern matching on any values, with convenient syntax for
primitives, and powerful composition of condition types when you need the extra power.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install --save pattahn
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn add pattahn
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`When you require/import 'pattahn' you get the main "match" function. Deep imports are
used to access other APIs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import match from 'pattahn';
import Eq from 'pattahn/cond/Eq';
import Test from 'pattahn/cond/Test';

const matcher = match()
  .with(Eq('foo').or(Eq('bar')), (value) => 'eq foo/bar')
  .with(
    Test((v) => v.length === 0),
    'empty',
  )
  .any((other) => 'other: ' + other);

matcher.exec('foo'); // => 'eq foo/bar'
matcher.exec(''); // => 'empty'
matcher.exec('baz'); // => 'other: baz'
`}</code></pre>
    <p>{`You can also match directly by using an object. Conditions can be used with the ES6
dynamic key syntax.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import match from 'pattahn';

const result = match('foo', {
  foo: 'eq foo',
  [Eq('bar').or(Eq('baz'))]: 'foo or baz',
  _: 'default',
});

result; // => 'eq foo'
`}</code></pre>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://brigand.github.io/pattahn/"
      }}>{`API Documentation`}</a>{` for more details.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      